var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_1043)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#112765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8397 8.32007H12.1599C10.0482 8.32007 8.32001 10.0482 8.32001 12.16V19.8402C8.32001 21.9514 10.0482 23.6801 12.1599 23.6801H19.8397C21.9515 23.6801 23.6796 21.9514 23.6796 19.8402V12.16C23.6796 10.0482 21.9515 8.32007 19.8397 8.32007ZM22.3996 19.8402C22.3996 21.2513 21.2517 22.4 19.8397 22.4H12.1599C10.7486 22.4 9.60004 21.2513 9.60004 19.8402V12.16C9.60004 10.7484 10.7486 9.6001 12.1599 9.6001H19.8397C21.2517 9.6001 22.3996 10.7484 22.3996 12.16V19.8402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1604 12.7998C20.6905 12.7998 21.1203 12.37 21.1203 11.8399C21.1203 11.3097 20.6905 10.8799 20.1604 10.8799C19.6302 10.8799 19.2004 11.3097 19.2004 11.8399C19.2004 12.37 19.6302 12.7998 20.1604 12.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 12.1599C13.8786 12.1599 12.1599 13.8788 12.1599 15.9998C12.1599 18.12 13.8786 19.8401 15.9998 19.8401C18.1204 19.8401 19.8397 18.12 19.8397 15.9998C19.8397 13.8788 18.1204 12.1599 15.9998 12.1599ZM15.9998 18.5601C14.5861 18.5601 13.4399 17.4139 13.4399 15.9998C13.4399 14.5858 14.5861 13.4399 15.9998 13.4399C17.4135 13.4399 18.5597 14.5858 18.5597 15.9998C18.5597 17.4139 17.4135 18.5601 15.9998 18.5601Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_1043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.74485db1471b0be8468066242b9e900f.svg";
export { ForwardRef as ReactComponent };